export enum Authority {
  ROLE_ANONYMOUS = 'ROLE_ANONYMOUS',
  ROLE_USER = 'ROLE_USER',
  ROLE_MAGISTRATE_INSIDE = 'ROLE_MAGISTRATE_INSIDE',
  ROLE_MAGISTRATE_OUTSIDE = 'ROLE_MAGISTRATE_OUTSIDE',
  AMA_ACCESS = 'ROLE_AMA_ACCESS',
}
